import React, { memo } from 'react';
import { Card, Col } from 'react-bootstrap';
import CountUp from 'react-countup';
import PropTypes from 'prop-types';

const GlassCard = ({ title, heroValue = {}, colour = '', sm = 12, md = 6, lg = 4, xl = 4, height = 400, children, loading = false }) => {
    const borderClass = `border border-start border-${colour} border-5 border-bottom-0 border-end-0 border-top-0`;
    return (
        <Col sm={sm} md={md} lg={lg} xl={xl}>
            <Card style={{ height }}>
                <Card.Header className={`text-muted h5${colour ? ' ' + borderClass : ''}`}>
                    <div
                        className={`${heroValue?.value != null ? 'text-end' : 'text-start float-start'}`}
                        dangerouslySetInnerHTML={{ __html: title }}>
                    </div>
                    {(heroValue?.value == null && heroValue.func != null) &&
                        <div className='text-end float-end'>
                            <button disabled={loading} className='btn btn-light btn-sm text-muted' onClick={() => heroValue?.func && heroValue?.func()}>View All</button>
                        </div>}
                </Card.Header>
                {heroValue?.value != null ?
                    <div
                        className={`fw-bold display-7 ps-4 fs-4 position-absolute mt-4 ${heroValue?.class && heroValue?.class}${heroValue?.func ? ' cursor-pointer' : ''}`}
                        onClick={() => heroValue?.func && heroValue?.func()}>
                        <CountUp
                            end={heroValue?.value}
                            duration={2}
                            suffix={heroValue?.suffix || ''}
                            prefix={heroValue?.prefix || ''}
                            decimals={heroValue?.decimals || 0}
                        />
                    </div> : ''}
                <Card.Body className='p-0'>{children}</Card.Body>
            </Card>
        </Col>
    );
}

GlassCard.propTypes = {
    title: PropTypes.string,
    sm: PropTypes.number,
    md: PropTypes.number,
    lg: PropTypes.number,
    xl: PropTypes.number,
    height: PropTypes.number,
    sla: PropTypes.string,
    children: PropTypes.node,
    heroValue: PropTypes.object,
    colour: PropTypes.string,
    loading: PropTypes.bool,
};

export default memo(GlassCard);